export const getImagePath = (url) => {
	// return `${window.location.origin}${url}`;
	if (url) {
		return `${url}`;
	}
	return "/img/not-image.jpeg";
};
